import { RecorderStore } from './stores/recorder.store';
import { ShareService } from './services/share.service';
import { Recorder } from './entities/recorder';
import { Player } from './entities/player';
import { ModalComponent } from '../shared/components/modal/modal.component';
var RecComponent = /** @class */ (function () {
    function RecComponent(recorderStore, shareService, recorder, player) {
        this.recorderStore = recorderStore;
        this.shareService = shareService;
        this.recorder = recorder;
        this.player = player;
    }
    RecComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.onRecordUrlSubscriber = this.shareService.onRecordUrl
            .subscribe(function (recordUrl) { return _this.onRecordUrl(recordUrl); });
    };
    RecComponent.prototype.ngOnDestroy = function () {
        this.onRecordUrlSubscriber.unsubscribe();
    };
    Object.defineProperty(RecComponent.prototype, "playback", {
        get: function () {
            return this.player.playback;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecComponent.prototype, "recording", {
        get: function () {
            return this.recorder.recording;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecComponent.prototype, "noRecord", {
        get: function () {
            return this.recorderStore.recordData.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecComponent.prototype, "singleLayer", {
        get: function () {
            return this.recorderStore.recordData.layerIds.length === 1;
        },
        enumerable: true,
        configurable: true
    });
    RecComponent.prototype.onRecordUrl = function (recordUrl) {
        this.recordUrl = recordUrl;
        this.shareModal.openModal();
    };
    return RecComponent;
}());
export { RecComponent };



// WEBPACK FOOTER //
// ./src/app/rec/rec.component.ts.pre-build-optimizer.js